<template>
  <smd-note class="form-required-note">
    <text-string label-id="txt133"/>
  </smd-note>
</template>

<script>
  export default {
    name: 'form-required-note',
  }
</script>

<style lang="scss">
  .form-required-note {
    p {
      text-align: center;
      font-style: italic;
    }
  }
</style>
